import { RegistrationEmailVerificaitonProps } from 'features/registration/interface/registration';
import { FC } from 'react';
import Checkbox from 'shared/components/form/checkbox';
import FormRow from 'shared/components/form/formRow';
import InputText from 'shared/components/form/inputText';
import useInputFocus from 'shared/hooks/useInputFocus';
import { addSpaces, disableInputAlphabets } from 'shared/util/utility';

const RegistrationStep6: FC<RegistrationEmailVerificaitonProps> = ({
	setEmailVerification,
	isFieldValueValid,
	errors,
	touched,
	setFieldValue,
	values,
	handleBlur,
	t,
}) => {
	const inputRef = useInputFocus();

	return (
		<>
			<FormRow flex={false}>
				<InputText
					autoFocus
					inputRef={inputRef}
					label={t('phoneNum')}
					name="phoneNum"
					isFieldValueValid={isFieldValueValid}
					errors={errors}
					touched={touched}
					onBlur={handleBlur}
					setFieldValue={setFieldValue}
					values={values}
					onChange={(e) => setFieldValue('phoneNum', disableInputAlphabets(e))}
					inputProps={{ inputMode: 'numeric', maxLength: 11 }}
					formatValue={addSpaces(values.phoneNum, 3)}
					cyTestRef="phone-number"
					cyErrorRef="reg-validation-error"
				/>
			</FormRow>
			<Checkbox
				name="emailVerification"
				label={t('emailActivationLabel')}
				values={values}
				isFieldValueValid={isFieldValueValid}
				touched={touched}
				errors={errors}
				setFieldValue={setFieldValue}
				onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
					setEmailVerification(e.target.checked);
					setFieldValue('emailVerification', e.target.checked);
				}}
				cyTestRef="checkbox-input"
			/>
		</>
	);
};

export default RegistrationStep6;
